// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"1c98e1f8882fa96795ed","293":"7499a5231cdc545ba7c9","518":"ab8986c7627a28d0076b","779":"23b0b7217cc4bd606d26"}[chunkId] + ".js";
};